import { render } from "./SwitchSite.vue?vue&type=template&id=2225adce&ts=true"
import script from "./SwitchSite.vue?vue&type=script&lang=ts"
export * from "./SwitchSite.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__